import quizIntroImage from "@/features/quiz/assets/quiz-intro.webp"
import { Button } from "@/components/ui/button"

interface QuizIntroStepProps {
  onAdvance: () => void
}

/**
 * Shared first screen for every quiz when `intro_v=prediction`. Owns its
 * layout (full-bleed, no quiz header). The CTA advances into the quiz.
 */
export function QuizIntroStep({ onAdvance }: QuizIntroStepProps) {
  return (
    <div
      data-slot="quiz-intro-step"
      className="relative flex flex-1 flex-col justify-between overflow-x-clip bg-dark-base px-4 pt-[max(2rem,env(safe-area-inset-top))] pb-[max(1rem,env(safe-area-inset-bottom))] text-purple-light"
    >
      <img
        src={quizIntroImage}
        alt=""
        className="pointer-events-none absolute top-[calc(50%-0.5px)] left-0 w-full -translate-y-1/2"
      />

      <h1 className="relative z-10 text-center font-display font-medium text-purple-light">
        <span className="block text-2xl leading-[33px]">WHEN YOU WILL</span>
        <span className="block text-[40px] leading-[54px] uppercase">have a baby?</span>
      </h1>

      <div className="relative z-10 flex flex-col items-center gap-3">
        <p className="text-center font-body text-base leading-[21.5px] text-purple-light/70">
          What if your baby's arrival
          <br />
          is closer than you imagine? Let's find out.
        </p>

        <Button variant="gradient" size="xl" className="font-medium" onClick={onAdvance}>
          See My Prediction
        </Button>

        <p className="text-center font-body text-xs text-purple-light/40">
          1 min · No sign-up · Photos not saved
        </p>
      </div>
    </div>
  )
}
